import { cn, getHoverCardColors, taskStatus } from "@/lib/utils"
import { CalendarDays, Clock, Folder } from "lucide-react"
import moment from "moment";

const TaskTooltipContent = ({task, onTaskClick}: {task: any, onTaskClick?: (data: any) => void}) => {
  const statusLabel = taskStatus[task?.actualStatus?.toLowerCase()]?.label;
  const hoverColors = getHoverCardColors(task?.actualStatus);
  
  return (
    <>
      <div className="flex justify-between items-start mb-2">
        <h4 className={cn("font-semibold text-[13px] text-gray-900 leading-tight w-[140px]", onTaskClick ? "hover:underline cursor-pointer" : "")} title={task?.taskName} onClick={() => onTaskClick?.(task)}>{task?.taskName}</h4>
        <span className={cn("text-[10px] font-medium px-2 py-0.5 rounded-full whitespace-nowrap", hoverColors.tagBg, hoverColors.tagText)}>{statusLabel}</span>
      </div>
      <div className="flex items-center gap-1.5 mb-1.5 text-gray-600">
        <Folder className="w-[14px] h-[14px] text-gray-500" />
        <span className="text-[11px] truncate" title={task?.categoryName}>{task?.categoryName || ''}</span>
      </div>
      {task?.subCategoryName && (
        <div className="flex items-center gap-1.5 mb-2 ml-4 text-gray-600">
          <Folder className="w-[14px] h-[14px] text-gray-500" />
          <span className="text-[11px] truncate" title={task?.subCategoryName}>{task?.subCategoryName}</span>
        </div>
      )}
      <div className={cn("flex items-center gap-1.5 mb-1.5 text-gray-600 border-t pt-2 mt-2", hoverColors.sepBorder)}>
        <CalendarDays className="w-[14px] h-[14px] text-gray-500" />
        <span className="text-[11px]">
          {task?.plannedStartDate ? moment(task?.plannedStartDate).format('MM-DD-YYYY') : ''} to {task?.plannedEndDate ? moment(task?.plannedEndDate).format('MM-DD-YYYY') : ''}
        </span>
      </div>
      <div className="flex items-center gap-1.5 text-gray-600">
        <Clock className="w-[14px] h-[14px] text-gray-500" />
        <span className="text-[11px]">Duration : {task?.plannedDurationDays || 0} Days</span>
      </div>
    </>
  )
}

export default TaskTooltipContent;